module.exports = __webpack_public_path__ + "static/flags/CW-1b97d82c71c8f6a45f63fedfed7aa3d8.gif";